import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import { loadSocialWallPostAction } from '../../reducers/socialwall.reducers';
import SingleSocialWallPost from './single-socialwall-post';

const mapDispatchToProps = dispatch => ({
  loadPost: id => dispatch(loadSocialWallPostAction(id)),
});

const mapStateToProps = state => ({
  post: state.socialwall.currentPost,
  loading: state.socialwall.singlePostLoading,
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSocialWallPost);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/single-socialwall-post.container.js